import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["bookCode", "itemCode"]

  connect() {
    console.log("Connected");
    this.updateItemCodeOnLoad(); // Chame esta função para configurar inicialmente as opções de itemCode
  }

  updateItemCodeOnLoad() {
    // Isso irá reconstruir as opções de itemCode baseado no valor atual de bookCode quando a página carrega
    const bookCode = this.bookCodeTarget.value;
    this.updateOptions(bookCode); // Atualize as opções de itemCode baseado no valor atual de bookCode
  }

  updateitemCode() {
    const bookCode = this.bookCodeTarget.value;
    this.updateOptions(bookCode); // Refatorado para usar uma função comum para atualizar as opções
  }
  updateOptions(bookCode) {
    console.log(`Selected Book Code: ${bookCode}`); // Isso é chamado quando o bookCode muda
    let options = '';
    if (bookCode === 'PAI') {
      console.log("Dentro do PAI");
      options = `<option value="Todos">Todos</option>
                  <option value="GR">GR</option>
                  <option value="S">S</option>
                  <option value="SD">SD</option>
                  <option value="SDZ">SDZ</option>
                  <option value="SP">SP</option>
                  <option value="SPZ">SPZ</option>
                  <option value="SS">SS</option>
                  <option value="SSZ">SSZ</option>
                  <option value="SZ">SZ</option>`;

    } else if (bookCode === 'MKP') {
      options = `<option value="Todos">Todos</option>
      <option value="FREEL">FREEL</option>
      <option value="PFREE">PFREE</option>
      <option value="FEEFL">FEEFL</option>
      <option value="BUSIN">BUSIN</option>
      <option value="FEEBS">FEEBS</option>
      <option value="PBUSIN">PBUSIN</option>
      <option value="FREELA">FREELA</option>
      <option value="BUSINA">BUSINA</option>`;
    }
    this.itemCodeTarget.innerHTML = options;
    this.restoreSelectedItemCode();
  }
  updateItemCodeSelection() {
    // Esta função será chamada quando o valor de itemCode mudar
    const selectedItemCode = this.itemCodeTarget.value;
    localStorage.setItem('selectedItemCode', selectedItemCode); // Salve a seleção no armazenamento local
  }

  restoreSelectedItemCode() {
    const selectedItemCode = localStorage.getItem('selectedItemCode');
    if (selectedItemCode) {
      this.itemCodeTarget.value = selectedItemCode;
    }
  }
}
